<ng-template #template>
  <ng-content></ng-content>
</ng-template>
<ion-item class="list-item transparent-bg settings-item item-noborder padding-bottom-s">
  <ion-label class="text-color-primary label-text-m ion-label-input">{{label}}</ion-label>
  <ion-input [type]="type" [disabled]="_disabled" class="text-left info-text-m" [placeholder]="placeholder"
    [(ngModel)]="_prop" ngDefaultControl (input)="onChange()">
  </ion-input>
</ion-item>